import './bootstrap';
import * as bootstrap from 'bootstrap';
import DataTable from 'datatables.net-dt';

// import '../css/dark-style.css';
import '../css/skin-modes.css';
// import '../css/color1.css';
// import '../css/style.css';


// import '../css/iconfonts/bootstrapicons/bootstrap-icons.css';
// import '../css/iconfonts/font-awesome/css/font-awesome.min.css';
// import '../css/iconfonts/glyphicons/glyphicon.css';
// import '../css/iconfonts/linearicons/Linearicons.css';
// import '../css/iconfonts/materialdesignicons/materialdesignicons.css';
// import '../css/iconfonts/pe-icon-7-stroke/Pe-icon-7.css';
// import '../css/iconfonts/simple-line-icons/simple-line-icons.css';
// import '../css/iconfonts/themify/themify.css';
// import '../css/iconfonts/typicons/typicons.css';
// import '../css/iconfonts/weathericons/weathericons.css';
// import '../css/iconfonts/feather/feather.css';
// import '../css/iconfonts/remixicon/remixicon.css';
import * as feather from 'feather-icons';

import '../landing/css/bootstrap.css';
import '../css/dark-theme-override.css';
// import '../landing/css/style.css';

// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', () => {
    const toggleBtn = document.querySelector('.navbar-toggle');
    const navigation = document.getElementById('navigation');

    if (toggleBtn && navigation) {
        toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();

            // Toggle open class on navigation
            navigation.classList.toggle('open');

            // Toggle open class on button for animation
            toggleBtn.classList.toggle('open');

            // Update aria-expanded
            const isExpanded = navigation.classList.contains('open');
            toggleBtn.setAttribute('aria-expanded', isExpanded);
        });
    }

    // Mobile Submenu Toggle
    const submenuParents = document.querySelectorAll('.has-submenu > a');
    submenuParents.forEach(link => {
        link.addEventListener('click', (e) => {
            // Only handle on mobile (≤991px)
            if (window.innerWidth > 991) return;

            e.preventDefault();
            const parentLi = link.parentElement;

            // Close sibling submenus at the same level
            const siblings = parentLi.parentElement.querySelectorAll(':scope > .has-submenu.open');
            siblings.forEach(sibling => {
                if (sibling !== parentLi) {
                    sibling.classList.remove('open');
                }
            });

            // Toggle this submenu
            parentLi.classList.toggle('open');
        });
    });

    // Sticky Navbar
    const navbar = document.getElementById('topnav');
    if (navbar) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                navbar.classList.add('nav-sticky');
            } else {
                navbar.classList.remove('nav-sticky');
            }
        });
    }

    // Cookie Consent
    const cookiePopup = document.querySelector('.cookie-popup');
    const cookieAcceptBtn = document.querySelector('.cookies-accept');

    if (cookiePopup && cookieAcceptBtn) {
        // Check if user has already accepted cookies
        if (!localStorage.getItem('cookieAccepted')) {
            // Show popup if not accepted
            cookiePopup.style.display = 'block';
        } else {
            // Hide if already accepted
            cookiePopup.style.display = 'none';
        }

        cookieAcceptBtn.addEventListener('click', (e) => {
            e.preventDefault();
            // Save preference
            localStorage.setItem('cookieAccepted', 'true');
            // Hide popup
            cookiePopup.style.display = 'none';
        });
    }

    // Back to Top functionality
    const backToTopBtn = document.getElementById('back-to-top');
    if (backToTopBtn) {
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                backToTopBtn.style.display = "block";
            } else {
                backToTopBtn.style.display = "none";
            }
        });

        // Add event listener (better than onclick)
        backToTopBtn.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        // Expose topFunction globally just in case HTML still uses onclick
        window.topFunction = function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        };
    }

    // Publications page: init DataTable with pagination (20 per page)
    const publicationsTable = document.getElementById('publications-datatable');
    if (publicationsTable) {
        new DataTable(publicationsTable, {
            pageLength: 20,
            lengthMenu: [[10, 20, 50, 100], [10, 20, 50, 100]],
            order: [[1, 'asc']],
            ordering: true,
            paging: true,
            layout: {
                topStart: 'pageLength',
                topEnd: 'search',
                bottomStart: 'info',
                bottomEnd: 'paging'
            },
            language: {
                search: 'Filter:',
                lengthMenu: 'Show _MENU_ entries',
                info: 'Showing _START_ to _END_ of _TOTAL_ publications',
                paginate: {
                    first: 'First',
                    last: 'Last',
                    next: 'Next',
                    previous: 'Previous'
                }
            }
        });
    }
});

import '../landing/js/landing.js';
// import '../landing/js/shuffle.min.js';
import '../landing/js/plugins.init.js';
import '../landing/js/bootstrap.bundle.min.js';
import '../landing/js/accordion.min.js';

import './socket.io.min.js';


import Swal from 'sweetalert2';
window.Swal = Swal;

import 'tiny-slider/dist/tiny-slider.css';
import { tns } from 'tiny-slider';
window.tns = tns;

window.callErrorToast = function (a, b, c) {
    Swal.fire({
        toast: true,
        position: 'bottom-end',
        icon: 'error',
        title: a,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
};

window.callSuccessToast = function (a, b, c) {
    Swal.fire({
        toast: true,
        position: 'bottom-end',
        icon: 'success',
        title: a,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
};
